export default "__VITE_ASSET__DTaE3BXB__"